import dompurify from 'dompurify';

let dp = null;

// HTML非法协议实例的REGEX
export const invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;

/**
 * 绑定DOMPurify的钩子
 * @param {*} dp
 */
function setHooks(dp) {
  dp.addHook("beforeSanitizeElements", (node) => {
    const notAllowTags = ["SCRIPT", "IFRAME", "STYLE"];
    if (notAllowTags.includes(node.nodeName)) {
      node.remove();
    }
  });

  dp.addHook("uponSanitizeAttribute", (node, attr) => {
    const regex = /.*\.js$/;
    if (
      attr.attrName === "src" &&
      node.nodeName === "IMG" &&
      regex.test(attr.attrValue)
    ) {
      attr.attrName = "";
      attr.attrValue = "";
      attr.keepAttr = false;
    }
  });

  dp.addHook("afterSanitizeAttributes", (node) => {
    if (node.nodeName === "A") {
      node.setAttribute("target", "_blank");
    }
  })
}

function getDpIns() {
  if (!dp) {
    dp = dompurify();

    setHooks(dp);
  }
  return dp;
}

/**
 * 使用DomPurify清理HTML
 * 适用于原来就有HTML的情况，例如富文本消息 频道公告卡片(ANCCard) 这种
 * @param {*} html
 * @param {*} config
 * @returns
 */
export function purifyHTML(html, config = {}) {
  const dp = getDpIns();

  const result = dp.sanitize(html, config);
  return result;
}

/**
 * 将尖括号处理成转义字符
 * 适用于只加hb-emoji的情况，房间，频道名字等
 * @param {*} htmlStr 
 * @returns 
 */
export function replaceAngleBracket(htmlStr) {
  if(!htmlStr) return '';
  return htmlStr.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// 将转义字符处理成尖括号
export function antiReplaceAngleBracket(htmlStr) {
  if(!htmlStr) return '';
  return htmlStr.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
}

// 拼接URL的协议
function combineURLProtocol(url){
  const regex = /^https?:\/\//;
  if(!regex.test(url)){
    return `http://${url}`;
  } else {
    return url;
  }
}

/**
 * 检查是否是合法的URL
 * 1. 判断是否以http://或https://开头，如果不是的话拼接请求头
 * 2. 判断是否包含非法重定向协议
 * 3. 如果new URL解析失败，则返回false
 */
export function isValidURL(url) {
  if (!url) return false;
  try {
    url = combineURLProtocol(url);
    const urlInfo = new URL(url);

    // 检查参数里是否有Script
    for (const [_key, value] of urlInfo.searchParams) {
      // 移除所有空白字符
      const cleanedValue = value.replace(/[\s]+/g, '');

      if (invalidProtocolRegex.test(cleanedValue.toLowerCase())) {
        return false;
      }
    }

    return true;
  } catch (e) {
    return false;
  }
}